/**
 * Monster Cart Translation for Langify (React-compatible version)
 * Detects the Langify language and translates the Monster Cart drawer's
 * (React-rendered) text using a static dictionary.
 *
 * Perf notes (rewritten): the previous version of this file ran a
 * document-wide click/submit listener, a forever-running 2s setInterval,
 * and re-fetched each Frequently-Bought-Together product's full HTML page
 * (just to scrape an <h1>) on every cart open/update. All of that ran
 * exactly during the Add to Cart -> checkout window. This version only
 * does work when the Monster drawer is actually present in the DOM, and
 * never issues extra network requests.
 */
(function() {
  const translations = {
    fr: {
      'votre panier': 'votre panier',
      'Ajouter au panier': 'Ajouter au panier',
      'ajouter au panier': 'ajouter au panier',
      'Sous-total': 'Sous-total',
      'Continuer Magasinage': 'Continuer Magasinage',
      'Voir le panier': 'Voir le panier',
      'Paiement': 'Paiement',
      'Commander': 'Commander',
      'Panier': 'Panier',
      'Votre panier est vide': 'Votre panier est vide',
      'Livraison': 'Livraison',
      'Total': 'Total',
      'Supprimer': 'Supprimer',
      'Quantité': 'Quantité',
      'code de coupon': 'code de coupon',
      'fréquemment achetés ensemble': 'fréquemment achetés ensemble',
      'Ou 4 paiements de': 'Ou 4 paiements de',
      'avec': 'avec',
      'show details': 'show details',
      'Ajouter': 'Ajouter',
      'Voir les détails': 'Voir les détails',
      'Détails': 'Détails',
      'Ajouter tous au panier': 'Ajouter tous au panier',
      'Total:': 'Total:',
      'Économisez': 'Économisez',
      '🎉 vous avez débloqué Un cadeau Gratuit': '🎉 vous avez débloqué Un cadeau Gratuit',
      'vous avez débloqué Un cadeau Gratuit': 'vous avez débloqué Un cadeau Gratuit',
      'Articles fréquemment achetés ensemble': 'Articles fréquemment achetés ensemble',
      'Produits recommandés': 'Produits recommandés',
      'Atteint': 'Atteint',
      'obtiens un produit gratuit': 'obtiens un produit gratuit',
      'obtiens un produit gratuit🎁': 'obtiens un produit gratuit🎁',
      'ajoutez': 'ajoutez',
      'pour débloquer Cadeau Gratuit': 'pour débloquer Cadeau Gratuit',
      'Cadeau Gratuit': 'Cadeau Gratuit',
      'OU': 'OU',
      'entrez le coupon': 'entrez le coupon',
      'appliquer': 'appliquer',
      'fermer': 'fermer',
      'Gratuit': 'Gratuit',
      'afficher les détails': 'afficher les détails',
      'sécurisé et garanti': 'sécurisé et garanti',
      'Retour au panier': 'Retour au panier',
      'Continuer magasinage': 'Continuer magasinage',
      'pour bénéficier de la livraison gratuite': 'pour bénéficier de la livraison gratuite',
      'remise': 'remise',
      'Achetez ': 'Achetez ',
      ' économisez ': ' économisez ',
      'chacun': 'chacun', 'Vous avez débloqué un cadeau gratuit': 'Vous avez débloqué un cadeau gratuit', 'Félicitations ! Votre cadeau sera ajouté automatiquement à votre commande.': 'Félicitations ! Votre cadeau sera ajouté automatiquement à votre commande.', 'Atteignez': 'Atteignez', 'et obtenez un produit gratuit': 'et obtenez un produit gratuit', 'pour débloquer votre cadeau gratuit': 'pour débloquer votre cadeau gratuit', 'Ajoutez': 'Ajoutez', 'Changer de cadeau': 'Changer de cadeau', 'Ventouses pour le visage': 'Ventouses pour le visage', 'Dermaroller 3 en 1': 'Dermaroller 3 en 1', 'Patches réutilisables & lumineuses pour le contour des yeux': 'Patches réutilisables & lumineuses pour le contour des yeux', 'La livraison est gratuite': 'La livraison est gratuite', 'Livraison gratuite': 'Livraison gratuite', 'Ventouses pour le visage': 'Ventouses pour le visage', 'Dermaroller 3 en 1': 'Dermaroller 3 en 1', 'Patches réutilisables & lumineuses pour le contour des yeux': 'Patches réutilisables & lumineuses pour le contour des yeux', 'La livraison est gratuite': 'La livraison est gratuite', 'Livraison gratuite': 'Livraison gratuite', 'Cadeau gratuit': 'Cadeau gratuit', 'Tisane « Ciao rétention d’eau »': 'Tisane « Ciao rétention d’eau »', 'Exfoliant corporel à la vanille': 'Exfoliant corporel à la vanille', 'Sels de bain - Tangerine & eucalyptus': 'Sels de bain - Tangerine & eucalyptus', 'Baume fermeté au matcha & pamplemousse rose pour le corps': 'Baume fermeté au matcha & pamplemousse rose pour le corps', 'Roulette fermeté': 'Roulette fermeté', 'Ventouses pour le corps': 'Ventouses pour le corps', 'Masque visage - Raffermissant & régénérant': 'Masque visage - Raffermissant & régénérant',
      'Félicitation! ton produit sersa automatiquement dans ta commande.': 'Félicitation! ton produit sersa automatiquement dans ta commande.',
      'Tu as débloqué ceci !': 'Tu as débloqué ceci !'
    },
    en: {
      'votre panier': 'your cart',
      'Ajouter au panier': 'Add to cart',
      'ajouter au panier': 'add to cart',
      'Sous-total': 'Subtotal',
      'Continuer Magasinage': 'Continue Shopping',
      'Voir le panier': 'View cart',
      'Paiement': 'Checkout',
      'Commander': 'Checkout',
      'Panier': 'Cart',
      'Votre panier est vide': 'Your cart is empty',
      'Livraison': 'Shipping',
      'Total': 'Total',
      'Supprimer': 'Remove',
      'Quantité': 'Quantity',
      'code de coupon': 'coupon code',
      'fréquemment achetés ensemble': 'frequently bought together',
      'Ou 4 paiements de': 'Or 4 payments of',
      'avec': 'with',
      'show details': 'show details',
      'Ajouter': 'Add',
      'Voir les détails': 'View details',
      'Détails': 'Details',
      'Ajouter tous au panier': 'Add all to cart',
      'Total:': 'Total:',
      'Économisez': 'Save',
      '🎉 vous avez débloqué Un cadeau Gratuit': '🎉 You have unlocked a free gift',
      'vous avez débloqué Un cadeau Gratuit': 'You have unlocked a free gift',
      'Articles fréquemment achetés ensemble': 'Frequently bought together items',
      'Produits recommandés': 'Recommended products',
      'Atteint': 'Reach',
      'obtiens un produit gratuit': 'to get a free product',
      'obtiens un produit gratuit🎁': 'to get a free product🎁',
      'ajoutez': 'add',
      'pour débloquer Cadeau Gratuit': 'to unlock your Free Gift',
      'Cadeau Gratuit': 'Free Gift',
      'OU': 'OR',
      'entrez le coupon': 'enter coupon',
      'appliquer': 'apply',
      'fermer': 'close',
      'Gratuit': 'Free',
      'afficher les détails': 'show details',
      'sécurisé et garanti': 'secure and guaranteed',
      'Retour au panier': 'Back to Cart',
      'Continuer magasinage': 'Continue Shopping',
      'pour bénéficier de la livraison gratuite': 'to continue enjoying free shipping',
      'remise': 'discount',
      'Achetez ': 'Buy ',
      ' économisez ': ' save ',
      'chacun': 'each', 'Vous avez débloqué un cadeau gratuit': 'You have unlocked a free gift', 'Félicitations ! Votre cadeau sera ajouté automatiquement à votre commande.': 'Congratulations! Your gift will be added to your order automatically.', 'Atteignez': 'Spend', 'et obtenez un produit gratuit': 'and get a free gift', 'pour débloquer votre cadeau gratuit': 'to unlock your free gift', 'Ajoutez': 'Add', 'Changer de cadeau': 'Change gift', 'Ventouses pour le visage': 'Facial Suction Cups', 'Dermaroller 3 en 1': '3-in-1 Dermaroller', 'Patches réutilisables & lumineuses pour le contour des yeux': 'Reusable & Luminous Patches for the Eye Area', 'La livraison est gratuite': 'Shipping is free', 'Livraison gratuite': 'Free shipping', 'Cadeau gratuit': 'Free gift', 'Tisane « Ciao rétention d’eau »': '“Ciao Water Retention” Herbal Tea', 'Exfoliant corporel à la vanille': 'Vanilla Body Scrub', 'Sels de bain - Tangerine & eucalyptus': 'Bath Salts - Tangerine & Eucalyptus', 'Baume fermeté au matcha & pamplemousse rose pour le corps': 'Matcha & Pink Grapefruit Firming Body Balm', 'Roulette fermeté': 'Cellulite Roller', 'Ventouses pour le corps': 'Body Suction Cups', 'Masque visage - Raffermissant & régénérant': 'Face Mask - Firming & Regenerating',
      'Félicitation! ton produit sersa automatiquement dans ta commande.': 'Congratulations! Your product will automatically be included in your order.',
      'Tu as débloqué ceci !': 'You unlocked this!'
    }
  };

  const DRAWER_SELECTORS = [
    '[data-monster-cart]',
    '.monster-cart',
    '#monster-cart-drawer',
    '#monster-cart-wrapper',
    '#monster-upsell-cart',
    '[role="dialog"][aria-label*="cart" i]',
    '[role="dialog"][aria-label*="panier" i]'
  ];

  function getCurrentLanguage() {
    const path = window.location.pathname;
    if (path.startsWith('/en') || path.includes('/en/')) return 'en';
    return 'fr';
  }

  // Longest-first, computed once instead of on every text node.
  const sortedFrenchKeys = Object.keys(translations.fr).sort((a, b) => b.length - a.length);

  function translateText(root, lang) {
    if (!root) return;
    const dict = translations[lang] || translations.fr;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) textNodes.push(node);

    textNodes.forEach((textNode) => {
      const original = textNode.textContent;
      if (!original || !original.trim()) return;
      let translated = original;
      for (const frenchText of sortedFrenchKeys) {
        if (translated.indexOf(frenchText) === -1) continue;
        const englishText = dict[frenchText] || frenchText;
        translated = translated.split(frenchText).join(englishText);
      }
      if (original !== translated) textNode.textContent = translated;
    });

    root.querySelectorAll('[placeholder],[aria-label],[title]').forEach((el) => {
      ['placeholder', 'aria-label', 'title'].forEach((attr) => {
        const value = el.getAttribute(attr);
        if (!value) return;
        let translated = value;
        for (const frenchText of sortedFrenchKeys) {
          if (translated.indexOf(frenchText) === -1) continue;
          translated = translated.split(frenchText).join(dict[frenchText] || frenchText);
        }
        if (translated !== value) el.setAttribute(attr, translated);
      });
    });
  }

  function findDrawer() {
    for (const selector of DRAWER_SELECTORS) {
      const el = document.querySelector(selector);
      if (el) return el;
    }
    return null;
  }

  let observer = null;
  let observedDrawer = null;
  let pendingFrame = null;

  function runTranslation() {
    const drawer = findDrawer();
    if (!drawer) return;
    translateText(drawer, getCurrentLanguage());
    observeDrawer(drawer);
  }

  function scheduleTranslation() {
    // Coalesce bursts of triggers (mutation + cart event firing together)
    // into a single translation pass instead of running it repeatedly.
    if (pendingFrame) return;
    pendingFrame = requestAnimationFrame(() => {
      pendingFrame = null;
      runTranslation();
    });
  }

  function observeDrawer(drawer) {
    if (observedDrawer === drawer && observer) return;
    if (observer) observer.disconnect();
    observedDrawer = drawer;
    observer = new MutationObserver(() => {
      // translateText mutates text nodes itself; only re-run on the next
      // frame so we don't loop on our own writes.
      scheduleTranslation();
    });
    observer.observe(drawer, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    scheduleTranslation();

    // Bounded search for the drawer's first appearance (it's added to the
    // DOM lazily by the app). Stops as soon as it's found or after ~6s.
    let attempts = 0;
    const maxAttempts = 30;
    const poll = setInterval(() => {
      attempts++;
      if (findDrawer() || attempts >= maxAttempts) {
        clearInterval(poll);
        scheduleTranslation();
      }
    }, 200);

    ['cart:open', 'cart:updated', 'cart:refresh', 'drawer:open'].forEach((eventName) => {
      document.addEventListener(eventName, scheduleTranslation);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
